import { Fragment, useState, useRef, useMemo, useEffect } from "react";
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Input,
    Typography,
    Spinner,
    Textarea,
    Card,
    Switch,
} from "@material-tailwind/react";
import Select from 'react-select';

import AIcon from "../partials/AIcon";

import UploadPhoto from "../../components/upload/UploadPhoto";
import { useShared } from '../../hooks/useShared';
import { toast } from "react-toastify";
import AInput from "../fields/AInput";

import ASelect from "../fields/ASelect";
import ASwitch from "../fields/ASwitch";
import ItemsComp from "../fields/ItemsComp";
import APDate from "../fields/APDate";
import ARadio from "../fields/ARadio";

export default function AddNewDialog({ v }) {
    const { register, watch, control, handleSubmit, setValue, formState: { errors }, reset } = useForm(
        {
            defaultValues: { status: 1 }
        }
    );
    const { http, photo, setPhoto, consts, fetchModelCounts, getLanguage } = useShared();
    const [errorMessage, setErrorMessage] = useState(null)
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        //set dialog data which comes from parent
        if (v.model?.id > 0)
            reset(v.model)
        // set image path
        const img = v.model?.image_path
        setPhoto({ url: img ? consts.BASE_URL + img : '', photo: null })
    }, [v.model])




    //Close Dialog
    const closeDialog = () => {
        v.setShowNewModelDialog(false)
        setLoading(false)
        v.setModel(null)
        mReset()
    }

    //Reset Dialog
    const mReset = () => {
        reset({})
    }


    const submit = async (submitData) => {
        setErrorMessage(null)

        console.log(v.url, ', submit ', submitData, v.models?.data);

        try {
            setLoading(true)
            const res = await http.post(`api/${v.mUrl?.create}`, submitData);

            console.log('model  ', res);

            if (res.data?.success) {
                const model = res.data?.data;

                v.refersh()
                // upload image if exists
                if (model?.id && photo) {

                    console.log(model)
                }

                // update table data
                if (submitData.id > 0) {
                    const data = v.models?.data
                    data.some((d, i) => {
                        if (d.id === model.id) {
                            data[i] = model
                            return true;
                        }
                    })
                    v.setModels(pre => ({ ...pre, [pre.data]: data }))

                } else { // Add to table data
                    const data = v.models.data
                    data.push(model);
                    v.setModels(pre => ({ [pre.data]: data, ...pre }))
                }

                toast.success(res.data.message);

                fetchModelCounts()
            }


            closeDialog() // close dialog

        } catch (error) {
            console.log(error);
            setLoading(false)
            const err = error?.response?.data

            if (!err?.success) {
                setErrorMessage(err?.message)
                toast.error(err?.message);
            }
        }
        return false
    }


    return (
        <Fragment>
            <Dialog open={v.showNewModelDialog} className={`min-w-[90%] md:min-w-[40%] border-main-color absolute top-0    `} size="lg"
                animate={{
                    mount: { scale: 1, y: 0 },
                    unmount: { scale: 0.9, y: -100 },
                }}
                style={{ direction: getLanguage() === "dr" ? 'rtl' : 'ltr' }}>

                <DialogHeader className="bg-main-color py-1 px-4 text-blue-gray-100  text-base flex justify-between ">
                    {v.title}
                    <Button className="p-0 m-0 bg-transparent" onClick={closeDialog}>  <AIcon name="close-outline" size={20} className="p-1" /> </Button>
                </DialogHeader>


                <DialogBody className={` overflow-y-scroll ${v?.className} `}>

                    <form className=" " onSubmit={handleSubmit(submit)}>
                        <div className=" grid  gap-6 items-baseline">

                            <div className='grid md:grid-cols-1 gap-3'>

                                {
                                    v.inputs?.map((data, i) => {
                                        return (
                                            <div key={i}>
                                                {
                                                    data?.type === 'text' || data.type === 'date' || data.type === 'email' || data.type === 'number' || data?.type === 'textarea' ?
                                                        <AInput v={{ register, errors, data }} />
                                                        : data?.type === 'select' ? <ASelect v={{ register, errors, control, data }} />
                                                            : data?.type === 'switch' ? <ASwitch v={{ register, errors, data }} />
                                                                : data?.type === 'radio' ? <ARadio v={{ register, errors, data, control }} />
                                                                    : data?.type === 'pdate' ? <APDate v={{ register, errors, control, setValue, data }} />
                                                                        : data?.type === 'items_comp' ? <ItemsComp v={{ register, errors, control, watch, data, items: 'items' }} />
                                                                            : data?.type === 'logo' ? <UploadPhoto v={{ obj: v.model?.logo_data, className: " ", modelName: v.modelName }} />
                                                                                : null
                                                }
                                            </div>
                                        )
                                    })
                                }

                            </div>

                        </div>
                        {errorMessage && <Typography
                            variant="small"
                            color="gray"
                            className="flex items-center text-red-500 gap-2 font-normal "
                        >
                            <AIcon name="alert-circle-outline" className="-mt-0.5 h-4 w-4" />
                            {errorMessage}
                        </Typography>}


                        <div className="flex flex-row justify-between px-4 py-2" style={{ direction: 'ltr' }}>

                            <Button variant="outlined" color="red" onClick={() => closeDialog()} className="py-0 px-1"> <AIcon name="close" size={20} /> </Button>
                            <div className='flex flex-row gap-4 md:justify-end '>
                                <Button variant="outlined" size='sm' color="gray" onClick={() => mReset()}>Reset</Button>
                                <Button className="btn1 w-full md:w-[90%] " size='sm' type="submit" >  {loading ? <Spinner color="teal" className="h-4 w-4" /> : "ارسال"}    </Button>

                            </div>

                        </div>
                    </form>
                </DialogBody>

            </Dialog>
        </Fragment>
    )
}
